<template>

    <open-invoices
        :data-uri="route('api.v1.financial.openinvoices.index')"
    ></open-invoices>

</template>

<script>

import OpenInvoices from "../../components/Business/OpenInvoices";

export default {

    components: {
        OpenInvoices,
    },

    metaInfo: {
        title:'Open Invoices',
    },

    name:'FinancialOpenInvoices',

}

</script>
